import { useState, useEffect, useContext } from "react";
import { Button, Form, Modal, Alert, Spinner } from "react-bootstrap";
import { FaCube } from "react-icons/fa";
import axios from "axios";
import { AuthContext } from "../../context/AuthContext";

const BASE_URL = process.env.REACT_APP_API_URL || "http://localhost:3000";

export default function IssueRawMaterialsModal({
  show,
  onHide,
  onSuccess,
  material,
}) {
  const { userData } = useContext(AuthContext);
  const [issuedQty, setIssuedQty] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  useEffect(() => {
    if (show) {
      setError("");
      setIssuedQty("");
    }
  }, [show, material]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError("");

    try {
      const qty = parseFloat(issuedQty);

      // Validation
      if (!qty || qty <= 0) {
        setError("Please enter a valid quantity greater than 0");
        setLoading(false);
        return;
      }

      if (qty > material.qty) {
        setError(`Cannot issue ${qty}. Only ${material.qty} available.`);
        setLoading(false);
        return;
      }

      const payload = {
        company_code: userData?.company_code,
        material_id: material.material_id,
        issued_qty: qty,
      };

      // Call API to issue the raw material
      const response = await axios.post(
        `${BASE_URL}/api/admin/raw-materials/issue`,
        payload,
      )

      if (response.data.success) {
        onSuccess("issued");
        onHide();
      } else {
        setError(response.data.message || "Failed to issue raw material");
      }
    } catch (err) {
      setError(
        err.response?.data?.message || "Failed to issue raw material. Please try again.",
      );
    } finally {
      setLoading(false);
    }
  };

  return (
    <Modal show={show} onHide={onHide} centered>
      <Modal.Header closeButton>
        <Modal.Title>Issue Raw Material</Modal.Title>
      </Modal.Header>

      <Modal.Body>
        {error && <Alert variant="danger">{error}</Alert>}

        {material && (
          <>
          <div className="d-flex justify-content-center py-3">
  <div className="border rounded-3 p-4 w-100 text-center" style={{ maxWidth: 420 }}>

    {/* Icon circle */}
    <div className="rounded-circle bg-primary bg-opacity-10 d-flex align-items-center justify-content-center mx-auto mb-3"
      style={{ width: 52, height: 52 }}>
      <FaCube size={20} className="text-primary" />
    </div>

    <p className="fw-semibold fs-5 mb-1">{material.name}</p>
    <p className="text-muted small mb-4">Raw Material</p>

    <div className="border-top pt-3 row g-2">
      <div className="col-6">
        <div className="bg-light rounded-2 p-3">
          <p className="text-muted mb-1" style={{ fontSize: 12 }}>Size</p>
          <p className="fw-semibold mb-0">{material.size || 'N/A'}</p>
        </div>
      </div>

      <div className="col-6">
        <div className="bg-light rounded-2 p-3">
          <p className="text-muted mb-1" style={{ fontSize: 12 }}>Available qty</p>
          <p className="fw-semibold mb-0">
            {material.qty}{' '}
            <span className="text-muted fw-normal small">{material.qty_type}</span>
          </p>
        </div>
      </div>
    </div>

  </div>
</div>

            <Form onSubmit={handleSubmit}>
              <Form.Group className="mb-3">
                <Form.Label>Quantity to Issue</Form.Label>
                <Form.Control
                  required
                  type="number"
                  min="0.01"
                  step="0.01"
                  max={material.qty}
                  placeholder="Enter quantity to issue"
                  value={issuedQty}
                  onChange={(e) => setIssuedQty(e.target.value)}
                  disabled={loading}
                />
                <Form.Text className="text-muted">
                  Max available: {material.qty} {material.qty_type || ""}
                </Form.Text>
              </Form.Group>

              <div className="d-flex gap-2">
                <Button
                  type="submit"
                  variant="primary"
                  className="flex-grow-1"
                  disabled={loading}
                >
                  {loading ? (
                    <>
                      <Spinner
                        as="span"
                        animation="border"
                        size="sm"
                        className="me-2"
                      />
                      Issuing...
                    </>
                  ) : (
                    "Issue Material"
                  )}
                </Button>
              </div>
            </Form>
          </>
        )}
      </Modal.Body>
    </Modal>
  );
}
